export default __webpack_public_path__ + "e8aa64c54acfc406a37b8e4570eb5165.png";